/*
 * Recersively clone all react elements.
 */
export default function cloneGrandchildren(elements, props = {}, rule = () => true) {
    return React.Children.map(elements, child => {
        return (React.isValidElement(child)) ?
            (child.props.children ?
                React.cloneElement(child, {
                    children: cloneGrandchildren(child.props.children, props, rule),
                    ...(rule(child) ? props : {}),
                })
                :
                cloneElements(child, props, rule))
            :
            child;
    });
}

/*
 * Clone react elements based on a specific rule function.
 */
export function cloneElements(elements, props = {}, rule = () => true) {
    return React.Children.map(elements, child => {
        return (React.isValidElement(child) && rule(child)) ?
            React.cloneElement(child, props)
            :
            child;
    });
}
